import { createAsyncAction, createAction } from "../createAction";
import * as commonTypes from "../common/actionTypes";
import * as types from "./actionTypes";

export const ESOCommonActions = createAction(
  types.ESO_COMMON,
  types.ESO_COMMON_SECONDARY,
  false
);
export const ACSeatCFGActions = createAction(
  types.AC_SEAT_CFG_MODAL,
  commonTypes.MODAL_ACTIONS
);

export const DashboardSearchCriteriaAction = createAsyncAction(
  types.DASHBOARD_SEARCH_CRITERIA
);

export const SoDashboardJobHistoryAction = createAction("SODASHBOARD", [
  types.STORE_JOB_HISTORY,
]);

export const SearchRuleAction = createAsyncAction(types.SEARCH_RULE);

export const SearchPollingPoliciesAction = createAsyncAction(
  types.SEARCH_POLLING_POLICIES
);

export const ServiceOrderQueryCriteriaAction = createAsyncAction(
  types.SERVICE_ORDER_QUERY_CRITERIA
);

export const SearchTopFocusItemsAction = createAsyncAction(
  types.SEARCH_TOP_FOCUS_ITEMS
);
export const SmartOrderDashboardAction = createAsyncAction(
  types.SMART_ORDER_DASHBOARD
);


export const ImportOrderQueryCriteriaAction = createAction(
  types.IMPORT_ORDER_QUERY_CRITERIA,
  ["SET"]
);
